module.exports = __webpack_public_path__ + "img/ícone-valido.5fcf8e7e.svg";